// extracted by mini-css-extract-plugin
export default {"tabs":"economic-basics_tabs__XYmgU"};